import { ComponentClassNames } from '../../util/classNames';
import { ITheme, memoizeFunction, mergeStyleSets } from '../../util/styling';

import {
  flexibleFlexStyleIE11Compatible,
  horizontalMargin,
  leftSidebarLeftMargin,
  minLeftSidebarRightMargin as marginRightStandard,
  maxLeftSidebarWidth,
  minLeftSidebarWidth,
  verticalGutterHeight as paddingTop,
  totalWidth,
} from './PageLayout.styles';
import { PageLayoutWidth } from './PageLayout.types';

const marginRightXLarge = 48 - horizontalMargin;

type LeftSidebarClassNames = ComponentClassNames<'leftSidebarColumn' | 'leftSidebarBorder'>;

export const getClassNames = memoizeFunction(
  (
    fullWidthLayout: boolean,
    theme: ITheme,
    topOffset: number,
    pageLayoutWidth: PageLayoutWidth | undefined
  ): LeftSidebarClassNames => {
    const isMedium = pageLayoutWidth === PageLayoutWidth.Medium;
    const isLarge = pageLayoutWidth === PageLayoutWidth.Large;
    const isXLarge = pageLayoutWidth === PageLayoutWidth.XLarge;

    const height = `calc(100vh - ${topOffset}px)`;

    const getConditionalStyles = () => {
      if (fullWidthLayout) {
        const leftSidebarMinWidth = 175;
        const leftSidebarMaxWidth = 275;
        const widthPercentage = 100 * (leftSidebarMaxWidth / totalWidth);
        const flex = isLarge ? `1 1 ${widthPercentage}%` : flexibleFlexStyleIE11Compatible;

        return {
          backgroundColor: theme.semanticColors.bodyFrameBackground,
          flex,
          paddingLeft: 12,
          maxWidth: leftSidebarMaxWidth,
          minWidth: leftSidebarMinWidth,
          width: isMedium || isLarge ? `${widthPercentage}%` : '100%',
        };
      }

      const widthPercentage = 100 * (maxLeftSidebarWidth / totalWidth);
      const flex = isLarge ? `1 1 ${widthPercentage}%` : flexibleFlexStyleIE11Compatible;

      return {
        flex,
        marginLeft: leftSidebarLeftMargin,
        marginRight: isXLarge ? marginRightXLarge : marginRightStandard,
        maxWidth: maxLeftSidebarWidth,
        minWidth: minLeftSidebarWidth,
        width: isMedium || isLarge ? `${widthPercentage}%` : '100%',
      };
    };

    return mergeStyleSets({
      leftSidebarColumn: {
        paddingTop,
        height,
        marginTop: topOffset,
        position: 'sticky',
        top: topOffset,
        ...getConditionalStyles(),
      },
      leftSidebarBorder: {
        height: '100%',
      },
    });
  }
);
